<template>
  <div class="setUp">
    <ul class="list">
      <van-uploader :after-read="afterRead">
        <li class="flex_b head_wrap">
          <div><img :src="params.portrait " alt="" /></div>
          <div>
            <qdd-icon class="iconyou" color="#CBCBCB" size=".3rem"></qdd-icon>
          </div>
        </li>
      </van-uploader>
      <li class="flex_b ">
        <div><span>账号</span></div>
        <div>
          <span>{{ params.user_name }}</span>
        </div>
      </li>
      <li class="flex_b" @click="changeItem('请输入昵称', 'nick_name')">
        <div><span>昵称</span></div>
        <div>
          <span :class="params.nick_name == '' ? 'not' : 'gray'">{{
            params.nick_name != '' ? params.nick_name : '请输入昵称'
          }}</span>
        </div>
      </li>

      <li class="flex_b ">
        <div><span>手机号</span></div>
        <div>
          <span>{{ params.phone_mob }}</span>
        </div>
      </li>
    </ul>
    <ul class="list">
      <li class="flex_b" @click="changeItem('请输入姓名', 'name')">
        <div><span>姓名</span></div>
        <div>
          <span :class="params.name == '' ? 'not' : 'gray'">{{
            params.name != '' ? params.name : '请输入姓名'
          }}</span>
        </div>
      </li>
      <li class="flex_b " @click="showPop('gender')">
        <div><span>性别</span></div>
        <div>
          <span :class="params.gender == '' ? 'not' : 'gray'">{{
            params.gender == '' ? '请选择' : params.gender
          }}</span>
          <qdd-icon class="iconyou" color="#CBCBCB" size=".3rem"></qdd-icon>
        </div>
      </li>
      <li class="flex_b " @click="showPop('birthday')">
        <div><span>生日</span></div>
        <div>
          <span class="not" v-if="params.birthday == '' || params.birthday == '0000-00-00'">请选择</span>
          <span class="gray" v-else>{{ params.birthday }}</span>
          <qdd-icon class="iconyou" color="#CBCBCB" size=".3rem"></qdd-icon>
        </div>
      </li>
      <li class="flex_b " @click="showPop('marital')">
        <div><span>婚姻状况</span></div>
        <div>
          <span :class="params.marital == '' ? 'not' : 'gray'">{{
            params.marital == '' ? '请选择' : params.marital
          }}</span>
          <qdd-icon class="iconyou" color="#CBCBCB" size=".3rem"></qdd-icon>
        </div>
      </li>
      <li class="flex_b " @click="showPop('education')">
        <div><span>学历</span></div>
        <div>
          <span :class="params.education == '' ? 'not' : 'gray'">{{
            params.education == '' ? '请选择' : params.education
          }}</span>
          <qdd-icon class="iconyou" color="#CBCBCB" size=".3rem"></qdd-icon>
        </div>
      </li>
      <li class="flex_b" @click="changeItem('请输入邮箱', 'email')">
        <div><span>邮箱</span></div>
        <div>
          <span :class="params.email == '' ? 'not' : 'gray'">{{
            params.email != '' ? params.email : '请输入邮箱'
          }}</span>
          <qdd-icon class="iconyou" color="#CBCBCB" size=".3rem"></qdd-icon>
        </div>
      </li>
    </ul>
    <div class="btn" @click="out()">退出登录</div>

    <!-- 弹框 -->
    <div class="pop" v-if="isShowPop">
      <div class="popcontnet">
        <div class="popTitle">{{ cur }}</div>
        <div class="inputWrap">
          <input :placeholder="cur" v-model="curinput" />
        </div>
        <div class="hide-integral flex_a">
          <span @click="hideintegralPop()" class="gray">取消</span>
          <span @click="toSend()">提交</span>
        </div>
      </div>
    </div>

    <!-- 生日弹框 -->
    <van-popup v-model="pop" position="bottom">
      <van-datetime-picker v-model="currentDate" :min-date="minDate" :max-date="maxDate" type="date" @cancel="onCancel"
        @confirm="changeBirthday" v-if="popType == 'birthday'" />
      <van-picker v-else show-toolbar :columns="columns" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script>
  import icon from '@/components/iconfont'
  import { sendRequest } from '@/assets/public'
  import { Toast, Dialog } from 'vant'
  import axios from 'axios'
  import urlconfig from '@/config.js'
  export default {
    name: 'setUp',
    components: {
      'qdd-icon': icon,
    },
    data() {
      return {
        sexArray: ['保密', '男', '女'], //性别arr  //1,男 2女 10保密
        educationArray: ['保密', '高中及以下', '专科', '本科', '研硕及以上'], //学历arr   //1高中及以下 2专科 3本科 4.研硕及以上 10 保密
        marriageArray: [
          '保密',
          '未婚',
          '已婚', // 婚姻状态 1未婚 2已婚 10 保密
        ],
        columns: [], //当前picker
        params: {}, //用户信息
        cur: '', //当前输入框
        curinput: '', //输入框的内容
        curtext: '',
        isShowPop: false, //昵称姓名和邮箱弹框的显示状态
        pop: false, //弹框
        popType: '', //弹框类型
        currentDate: new Date(),
        maxDate: new Date(),
        minDate: new Date(1950, 0, 1),
      }
    },
    created() {
      // 获取用户信息
      this.getInfoData()
    },
    methods: {
      // 获取用户信息
      async getInfoData() {
        let res = await sendRequest('user/info', {type:'0'})
        // 性别
        switch (res.content.member.gender) {
          case '1':
            res.content.member.gender = '男'
            break
          case '2':
            res.content.member.gender = '女'
            break
          case '0':
            res.content.member.gender = ''
            break
          case '10':
            res.content.member.gender = '保密'
            break
          default:
        }
        // 婚姻状况
        switch (res.content.member.marital) {
          case '10':
            res.content.member.marital = '保密'
            break
          case '1':
            res.content.member.marital = '未婚'
            break
          case '0':
            res.content.member.marital = ''
            break
          case '2':
            res.content.member.marital = '已婚 '
            break
          default:
        }
        // 学历

        switch (res.content.member.education) {
          case '1':
            res.content.member.education = '高中及以下'
            break
          case '2':
            res.content.member.education = '专科'
            break
          case '3':
            res.content.member.education = '本科'
            break
          case '4':
            res.content.member.education = '研硕及以上'
            break
          case '0':
            res.content.member.education = ''
            break
          case '10':
            res.content.member.education = '保密'
            break
          default:
        }
        this.params = res.content.member
      },
      // 点击昵称姓名和邮箱  显示弹框
      changeItem(text, name) {
        this.isShowPop = true
        this.cur = text
        this.curinput = this.params[name]
        this.curtext = name
      },
      // 隐藏输入框弹框
      hideintegralPop() {
        this.isShowPop = false
      },
      // 显示底部弹框
      showPop(node) {
        this.pop = true
        this.popType = node
        if (node == 'gender') {
          // 性别
          this.columns = this.sexArray
        } else if (node == 'marital') {
          //婚姻状态
          this.columns = this.marriageArray
        } else if (node == 'education') {
          //学历
          this.columns = this.educationArray
        }
      },
      ss(event) {
        var reader = new FileReader() //创建读取文件的方法
        var img1 = event.target.files[0]

        reader.readAsArrayBuffer(img1)
        // reader.readAsDataURL(img1);//将文件已url的形式读入页面
        var that = this
        reader.onload = function (e) {
          // that.ruleForm.idImage= reader.result; //把图片的二进制流付给表单ruleForm里面的idImage
        }
      },
      // 修改生日
      async changeBirthday(e) {
        let starttime =
          this.currentDate.getFullYear() +
          '-' +
          (Number(this.currentDate.getMonth()) + 1) +
          '-' +
          this.currentDate.getDate()
        let res = await sendRequest('user/setUser', {
          birthday: starttime,
        })
        if (res.status != 200) {
          Toast(res.msg)
        } else {
          this.getInfoData()
          this.pop = false
          Toast('修改成功')
        }
      },
      // 修改性别,学历或婚姻状况
      async onConfirm(value, index) {
        if (this.popType == 'gender') {
          // 性别
          let gender = ''
          switch (value) {
            case '保密':
              gender = '10'
              this.params.gender = '保密'
              break
            case '男':
              gender = '1'
              this.params.gender = '男'
              break
            case '女':
              gender = '2'
              this.params.gender = '女'
              break
            default:
          }
          let res = await sendRequest('user/setUser', {
            gender: gender,
          })
          if (res.status != 200) {
            Toast(res.msg)
          } else {
            this.getInfoData()
            this.pop = false
            Toast('修改成功')
          }
        } else if (this.popType == 'marital') {
          // 婚姻状况
          let marital = ''
          switch (value) {
            case '保密':
              marital = '10'
              this.params.marital = '保密'
              break
            case '未婚':
              marital = '1'
              this.params.marital = '未婚'
              break
            case '已婚':
              marital = '2'
              this.params.marital = '已婚 '
              break
            default:
          }
          let res = await sendRequest('user/setUser', {
            marital: marital,
          })
          if (res.status != 200) {
            Toast(res.msg)
          } else {
            this.getInfoData()
            this.pop = false
            Toast('修改成功')
          }
        } else if (this.popType == 'education') {
          // 学历
          let education = ''
          switch (value) {
            case '保密':
              education = '10'
              this.params.education = '保密'
              break
            case '高中及以下':
              education = '1'
              this.params.education = '高中及以下'
              break
            case '专科':
              education = '2'
              this.params.education = '专科'
              break
            case '本科':
              education = '3'
              this.params.education = '本科'
              break
            case '研硕及以上':
              education = '4'
              this.params.education = '研硕及以上'
              break
            default:
          }
          let res = await sendRequest('user/setUser', {
            education: education,
          })
          if (res.status != 200) {
            Toast(res.msg)
          } else {
            this.getInfoData()
            this.pop = false
            Toast('修改成功')
          }
        }
      },
      // 隐藏底部弹框
      onCancel() {
        this.pop = false
      },
      // 提交昵称、姓名、邮箱
      async toSend() {
        let _this = this
        if (_this.curinput == '') {
          Toast('不能为空哦')
          return
        }

        if (_this.curtext == 'email') {
          let email = _this.curinput
          let regemail = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
          if (!regemail.test(email)) {
            Toast('请输入合法邮箱')
            return
          }
        }

        let data = {}
        data[_this.curtext] = _this.curinput
        let res = await sendRequest('user/setUser', data)
        if (res.status != 200) {
          Toast(res.msg)
        } else {
          _this.getInfoData()
          _this.isShowPop = false
          Toast('修改成功')
        }
      },
      // 退出登录
      out() {
        Dialog.confirm({
          message: '确定退出登录？',
        })
          .then(() => {
            // on confirm
            localStorage.removeItem('token')
            localStorage.removeItem('info')
            localStorage.removeItem('infor')
            Toast('退出成功')
            setTimeout(() => {
              window.location.href = `${urlconfig.goPath}` // 注意：测试访问域名
            }, 2000)
          })
          .catch(() => {
          })
      },

      // 上传头像
      async afterRead(file) {
        let res = await sendRequest('user/uploadImg', {
          file: file.content,
        })
        if (res.status == 200) {
          let result = await sendRequest('user/setUser', {
            portrait: res.content.object,
          })
          if (result.status == 200) {
            Toast('修改成功')
            this.getInfoData()
          } else {
            Toast(res.msg)
          }
        } else {
          Toast('修改失败')
        }
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .not {
    color: #cbcbcb;
  }

  .gray {
    color: #999;
  }

  .btn {
    width: 13.8rem;
    height: 1.76rem;
    line-height: 1.76rem;
    margin: 0.8rem auto;
    background: #fd3e3e;
    color: #fff;
    font-size: 0.64rem;
    text-align: center;
    border-radius: 0.2rem;
  }

  .list {
    background: #ffffff;
    padding: 0 0.8rem;
    margin-bottom: 0.4rem;
  }

  .list li {
    height: 1.76rem;
    line-height: 1.76rem;
    font-size: 0.56rem;
    border-bottom: 1px solid #ddd;
  }

  .list span {
    font-size: 0.56rem;
    margin-left: 0.4rem;
    display: inline-block;
  }

  .list a:last-child li {
    border-bottom: none;
  }

  .list li:last-child {
    border-bottom: none;
  }

  .list a {
    color: #2c3e50;
  }

  .popcontnet {
    width: 12.44rem;
    height: 7.32rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.2rem;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  .popTitle {
    text-align: center;
    font-size: 0.68rem;
    padding: 0.8rem 0 0.8rem;
    font-weight: bold;
  }

  .operation {
    padding: 0 0.64rem;
    font-size: 0.56rem;
    color: #666;
    line-height: 0.88rem;
  }

  .hide-integral {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2rem;
    line-height: 2rem;
    text-align: center;
    font-size: 0.68rem;
    color: #fd3e3e;
    border-top: 1px solid #ddd;
  }

  .hide-integral span {
    flex: 1;
  }

  .inputWrap input {
    width: 10rem;
    height: 1.76rem;
    line-height: 1.76rem;
    border: 1px solid rgba(221, 221, 221, 1);
    border-radius: 0.2rem;
    margin: 0 auto;
    padding: 0 0.4rem;
    text-align: center;
    font-size: 0.56rem;
    box-sizing: border-box;
    display: block;
  }

  .pop {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
  }

  .head_wrap {
    height: 2.8rem !important;
    line-height: 2.8rem !important;
  }

  .head_wrap img {
    width: 2rem;
    height: 2rem;
    margin-top: 0.4rem;
    border-radius: 50%;
  }
</style>